<p class="footer">Copyright © Todos os Direitos Reservados</p>
